/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./shared/store/state"
import getters from "./shared/store/getters"
import mutations from "./shared/store/mutations"
import actions from "./shared/store/actions"

Vue.use(Vuex)

import { authState } from './auth';
import { setupState } from './setup';
import { analyzeState } from './analyze'
import { sandboxState } from './sandbox';
import { optimizerState } from './optimizer';
import { predictorState } from './predictor';
import { competerState } from './competer';
import { onboardState } from './onboard';
import { usersState } from './users';
import { senserState } from './senser';
// import moduleAuth from './shared/store/auth/moduleAuth.js'

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      auth: authState,
      setup: setupState,
      analyze: analyzeState,
      sandbox: sandboxState,
      optimizer: optimizerState,
      predictor: predictorState,
      competer: competerState,
      onboard: onboardState,
      users: usersState,
      senser: senserState
    },
    strict: process.env.NODE_ENV !== 'production'
});
